// Customers are not charged from a saved card any more: Stripe and Paddle send every invoice with a payment link and
// bank transfer details. The add/change card UI and the saved card are hidden, the code behind them stays for later.
export const CARD_PAYMENTS_ENABLED = false
